import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put } from 'redux-saga/effects';
import { routes } from '../../../../constants';

const actions = createActions({
  SESSION: {
    LOGOUT_MOCK_USER: () => ({})
  }
})

export function* logoutMockUser(action) {
  yield put(push({ pathname: routes.adminPortal.dashboard }));
}

const configuration = {
  name: 'logoutMockUser',
  action: actions,
  sagas: logoutMockUser,
  reducers: {
    reducer: (state, { palyload }) => ({
      ...state,
      mockUserId: null,
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/session/configurations/logoutMockUser.js